import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { HOME_COLORS } from './common';

/** Auto-rotating full-bleed photo slider used behind the hero copy. Falls back to a plain gradient if there are no photos yet. */
export default function HeroSlider({ images = [], intervalMs = 5000 }) {
  const [index, setIndex] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    if (images.length < 2) return undefined;
    timer.current = setInterval(() => setIndex((i) => (i + 1) % images.length), intervalMs);
    return () => clearInterval(timer.current);
  }, [images.length, intervalMs]);

  return (
    <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      {images.length === 0 ? (
        <Box sx={{ position: 'absolute', inset: 0, background: `linear-gradient(160deg, ${HOME_COLORS.deep} 0%, ${HOME_COLORS.dark} 45%, ${HOME_COLORS.sky} 130%)` }} />
      ) : (
        images.map((img, i) => (
          <Box
            key={img.url}
            component="img"
            src={img.url}
            alt=""
            sx={{
              position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover',
              opacity: i === index ? 1 : 0,
              transform: i === index ? 'scale(1.06)' : 'scale(1)',
              transition: 'opacity 1.4s ease, transform 7s ease',
            }}
          />
        ))
      )}
      {/* Brand-colour wash so the hero copy stays readable over any photo, blending teal into sky blue */}
      <Box sx={{
        position: 'absolute', inset: 0,
        background: `linear-gradient(160deg, rgba(0,37,26,0.92) 0%, rgba(0,77,64,0.85) 40%, rgba(14,165,233,0.55) 130%)`,
      }} />

      {images.length > 1 && (
        <Box sx={{ position: 'absolute', bottom: 28, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 1, zIndex: 2 }}>
          {images.map((img, i) => (
            <Box
              key={img.url}
              onClick={() => setIndex(i)}
              sx={{
                width: i === index ? 26 : 8, height: 8, borderRadius: 4, cursor: 'pointer',
                bgcolor: i === index ? '#fff' : 'rgba(255,255,255,0.45)',
                transition: 'width 0.35s ease, background-color 0.35s ease',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
